import type { HomepageSection, ShopByBrandCopy } from "@workspace/api-client-react";

export type HomepageCopyField = "eyebrow" | "heading" | "subheading" | "ctaText";

export function resolveHomepageCopy(
  value: string,
  fallback: string,
  hidden: boolean,
  brandName = "",
): string {
  if (hidden) return "";
  return (value.trim() ? value : fallback)
    .replace(/\{brand\}/gi, brandName)
    .trim();
}

export function sectionCopyIsHidden(
  section: Pick<HomepageSection, "hiddenCopyFields"> | Pick<ShopByBrandCopy, "hiddenCopyFields">,
  field: HomepageCopyField,
): boolean {
  return section.hiddenCopyFields.includes(field);
}

export function sectionCopyFallback(
  section: Pick<HomepageSection, "kind" | "id">,
  field: HomepageCopyField,
): string {
  if (field === "eyebrow") {
    if (section.kind === "sale") return "A LITTLE SOMETHING OFF";
    if (section.kind === "hero") return "FROM PAKISTAN, WITH SPIRIT";
    if (section.kind === "brand-feature") return "{brand}";
    if (section.kind === "brand-strip") return "";
    if (section.kind === "shop-by-brand") return "FIND YOUR LABEL";
    return "A LITTLE MORE TO LOVE";
  }
  if (field === "heading") {
    if (section.kind === "hero") return "A Riot of Color";
    if (section.kind === "brand-feature") return "Shop by edit";
    if (section.kind === "sale") return "The Sale edit";
    if (section.kind === "shop-by-brand") return "Shop by brand";
    if (section.id.startsWith("how-it-works-")) return "How it works";
    if (section.kind === "brand-strip") return "";
    if (section.id === "brand-story") return "Good clothes. Far fewer miles.";
    return "Featured styles";
  }
  if (field === "ctaText") {
    if (section.kind === "hero" || section.kind === "brand-feature") return "SHOP {brand}";
    if (section.kind === "sale") return "SHOP ALL SALE";
    if (section.kind === "shop-by-brand") return "VIEW ALL {brand}";
    if (section.kind === "brand-strip") return "";
    return "VIEW ALL";
  }
  return "";
}

export function setHiddenCopyField(
  hiddenFields: HomepageCopyField[],
  field: HomepageCopyField,
  hidden: boolean,
): HomepageCopyField[] {
  return hidden
    ? [...new Set([...hiddenFields, field])]
    : hiddenFields.filter(item => item !== field);
}
